import { IteratorHelper } from 'choerodon-ui/dataset';
const { iteratorSome, iteratorEvery, iteratorFind, iteratorFindIndex, iteratorFilterToArray, iteratorReduce, iteratorSliceToArray, } = IteratorHelper;
export { iteratorSome, iteratorEvery, iteratorFind, iteratorFindIndex, iteratorFilterToArray, iteratorReduce, iteratorSliceToArray, };
